import React from 'react'
import { Result } from 'antd'
import { useTranslation } from 'lib/i18n'
import { useServerContext } from 'next-server-context'

import CtaButton from 'components/CtaButton/CtaButton'
import Link from 'components/Link/Link'
import PublicLayout from 'components/PublicLayout/PublicLayout'

export default function VideoRequestNotFound(): JSX.Element {
  const { t } = useTranslation()
  const serverContext = useServerContext()

  if (serverContext) serverContext.response.statusCode = 404

  return (
    <PublicLayout>
      <Result
        status="404"
        title={t('VideoRequestNotFound.title', 'memmo not found')}
        subTitle={t(
          'VideoRequestNotFound.subTitle',
          'Sorry, the memmo you were looking for does not exist.',
        )}
        extra={
          <Link href="/">
            <CtaButton type="primary">
              {t('VideoRequestNotFound.goBack', 'Check out our profiles')}
            </CtaButton>
          </Link>
        }
      />
    </PublicLayout>
  )
}
